import { cn } from '@/utils/styles/cn'
import { motion } from 'framer-motion'
import { useId } from 'react'

interface IErrorMessageProps {
    error: string | null
    style?: React.CSSProperties
    className?: string
}

export const ErrorMessage = ({ error, style, className }: IErrorMessageProps) => {
    const componentId = useId()

    if (!error) return null

    return (
        <motion.div
            initial={{ opacity: 0, y: -10, height: 0 }}
            animate={{ opacity: 1, y: 0, height: 'auto' }}
            exit={{ opacity: 0, y: -10, height: 0 }}
            transition={{
                opacity: { duration: 0.3, ease: 'easeOut' },
                height: { type: 'spring', stiffness: 700, damping: 50 },
                y: { type: 'spring', bounce: 0.1, duration: 0.4 },
            }}
            key={'labeled-error' + error + componentId}
            className="flex flex-col overflow-y-hidden"
            style={style}
        >
            <p
                className={cn('text-error text-destructive ml-1 mt-1 text-[12px] font-medium', className)}
                aria-label="error message"
            >
                {error}
            </p>
        </motion.div>
    )
}
